export const NAMESPACE = 'efi_data_filterableTabularData';
